import Configurator from "components/configure/Configurator";
import { usePageContext } from "context/PageContext";
import * as React from "react";

export default function HomePage() {
  const page = usePageContext();
  let pageHeight = page.size.height;

  return (
    <div>
      <Configurator
        pageHeight={pageHeight}
        onClose={() => {
          page.setPage({ section: "" });
        }}
      />
    </div>
  );
}
